import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "row justify-content-between" };
const _hoisted_3 = {
    key: 0,
    class: "col-auto"
};
const _hoisted_4 = { class: "col-auto" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "col-auto col-lg-8" };
const _hoisted_9 = { class: "col-auto col-lg-4" };
const _hoisted_10 = {
    key: 1,
    class: "modal-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_acl = _resolveDirective("acl");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode($setup["BModal"], {
            ref: "inspectHospitalRequest",
            "no-footer": "",
            centered: "",
            size: "xl",
            title: `${_ctx.$t('JTADM_HOSPITALS_HOSPITAL_REQUEST')} - ${$setup.hospital?.operation || _ctx.$t('JTADM_HOSPITALS_HOSPITAL_ORIGINAL')}`,
            onChange: _cache[0] || (_cache[0] = ($event) => ($setup.showOriginal = false))
        }, {
            default: _withCtx(() => [
                ($setup.hospital)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode($setup["BContainer"], { fluid: "" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    ($setup.isUpdate)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                            _createVNode($setup["BButtonGroup"], null, {
                                                default: _withCtx(() => [
                                                    _createVNode($setup["BButton"], {
                                                        class: _normalizeClass(["btn btn-primary", { 'btn-info text-white': !$setup.showOriginal }]),
                                                        onClick: $setup.toggleToRequest
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.$t('JTADM_HOSPITALS_UPDATE_REQUEST')), 1)
                                                        ]),
                                                        _: 1
                                                    }, 8, ["class"]),
                                                    _createVNode($setup["BButton"], {
                                                        class: _normalizeClass(["btn btn-secondary", { 'btn-info text-white': $setup.showOriginal }]),
                                                        onClick: $setup.toggleToOriginal
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.$t('JTADM_HOSPITALS_HOSPITAL_ORIGINAL')), 1)
                                                        ]),
                                                        _: 1
                                                    }, 8, ["class"])
                                                ]),
                                                _: 1
                                            })
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_4, [
                                        (!$setup.showOriginal)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('JTADM_HOSPITALS_REQUESTER')) + ": " + _toDisplayString($setup.hospital.requester), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t('JTADM_HOSPITALS_HOSPITAL_ORIGINAL')), 1))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createVNode($setup["HospitalSuggestion"], {
                                            "view-mode": "",
                                            "model-value": $setup.hospital
                                        }, null, 8, ["model-value"])
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                        ($setup.hospital?.certifications)
                                            ? (_openBlock(), _createBlock($setup["CertificationSelector"], {
                                                key: 0,
                                                "model-value": $setup.certificationIds,
                                                "view-mode": ""
                                            }, null, 8, ["model-value"]))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ]),
                            _: 1
                        })
                    ]))
                    : _createCommentVNode("", true),
                (!$setup.showOriginal)
                    ? (_openBlock(), _createElementBlock("footer", _hoisted_10, [
                        _withDirectives((_openBlock(), _createElementBlock("button", {
                            class: "btn btn-success",
                            type: "submit",
                            onClick: _withModifiers($setup.acceptRequest, ["prevent"])
                        }, [
                            _createTextVNode(_toDisplayString(_ctx.$t('JTADM_DIALOG_BUTTON_ACCEPT')), 1)
                        ])), [
                            [_directive_acl, $props.access, "root"]
                        ]),
                        _createElementVNode("button", {
                            class: "btn btn-danger",
                            onClick: _withModifiers($setup.rejectRequest, ["prevent"])
                        }, _toDisplayString(_ctx.$t('JTADM_DIALOG_BUTTON_REJECT')), 1)
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        }, 8, ["title"])
    ]));
}
